import { Component, Inject } from '@angular/core';
import { faUser, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@auth0/auth0-angular';
import { AsyncPipe, DOCUMENT, NgIf } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  NgbCollapse,
  NgbDropdown,
  NgbDropdownMenu,
  NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css'],
  standalone: true,
  imports: [
    FontAwesomeModule,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdown,
    NgbCollapse,
    AsyncPipe,
    NgIf,
    RouterLink,
    RouterLinkActive,
  ],
})
export class NavBarComponent {
  isCollapsed = true;
  faUser = faUser;
  faPowerOff = faPowerOff;
  companyNumber: any | string;

  constructor(
    public auth: AuthService,
    public session: SessionService,
    @Inject(DOCUMENT) private doc: Document
  ) {
  }

  loginWithRedirect() {
    this.auth.loginWithRedirect();
  }

  logout() {
    this.auth.logout({ logoutParams: { returnTo: this.doc.location.origin } });
  }

  viewQuotes() {
    return this.session.hasPermission("quote:read_all") || this.session.hasPermission("quote:read_team");
  }

  viewProducts() {
    return this.session.hasPermission("product:search");
  }

  viewDealDesk() {
    return this.session.hasPermission("dealdesk:create") ||
      this.session.hasPermission("dealdesk:read_owned") ||
      this.session.hasPermission("dealdesk:read_all");
  }

  viewReports() {
    return this.session.hasPermission("quote:report_all") || this.session.hasPermission("quote:report_team");
  }
}
